import React, { useEffect, useContext, useState } from 'react';
import { Grid, List, Placeholder } from 'semantic-ui-react';
import AuthContext from '../context/authContext';
import { Markup } from 'interweave';


function GetTooltipMemberTG({ member_id, member_name }) {
    const authContext = useContext(AuthContext);
    const [loading, setloading] = useState(false)
    const [membersInTeam, setmembersInTeam] = useState(null)
    const [additionaInfo, setadditionaInfo] = useState(null)


    useEffect(() => {

        if (authContext.subTournamentRoot) {
            setloading(true)
            getInfoMembers()
            setloading(false)
        }

        return () => {

        }; // use effect cleanup to set flag false, if unmounted
    }, [member_id, member_name])// eslint-disable-line react-hooks/exhaustive-deps


    function getInfoMembers() {
        try {
            if (authContext?.subTournamentRoot?.data?.member_type === "TEAM") {
                let m = authContext?.subTournamentRoot?.data?.members.find((m) => m.name === member_name).members_list
                if (m) {
                    setmembersInTeam(m)
                } else {
                    setmembersInTeam([])
                }

            } else {
                setmembersInTeam(null)
            }
            let m = null
            if (authContext?.subTournamentRoot?.viewAdmin) {
                m = authContext?.subTournamentRoot?.data?.members?.find((m) => m.name === member_name)?.additional_info
            } else {
                try {
                    m = authContext?.subTournamentRoot?.data?.members?.find((m) => m.name === member_name)?.additional_info
                    m = JSON.stringify(JSON.parse(m)?.filter((row) => row.name?.toUpperCase() === 'KLUB'))
                } catch (e) {
                    console.log(e)
                }

            }
            if (m) {
                setadditionaInfo(m)
            } else {
                setadditionaInfo(null)
            }
        } catch (e) {
            console.log(e)
            setmembersInTeam(null)
            setadditionaInfo(null)
        }

    }

    function get_additional_info(additional_info) {
        try {
            return <><Markup content={JSON.parse(additional_info).map(item => {
                // Sprawdzamy, czy wartość jest null, jeśli tak to używamy pustego ciągu znaków
                const value = item.value === null ? 'Brak podanych informacji' : item.value;
                if (item.enable) {
                    return `<b>${item.name}</b>: ${value} <br/>`;
                } else {
                    return ""
                }

            }).join('')} /></>
        } catch (e) {
            return <><Markup content={additional_info} /></>
        }
    }

    return (
        loading ? <Placeholder style={{ minWidth: '200px' }}>
            <Placeholder.Header>
                <Placeholder.Line />
                <Placeholder.Line />
            </Placeholder.Header>
            <Placeholder.Paragraph>
                <Placeholder.Line length='medium' />
                <Placeholder.Line length='short' />
            </Placeholder.Paragraph>
        </Placeholder> : authContext.subTournamentRoot == null || (membersInTeam === null && additionaInfo === null) ? <>{member_name}</> :
            <Grid style={{ minWidth: membersInTeam && additionaInfo ? 400 : 150 }} centered divided columns={membersInTeam && additionaInfo ? 2 : 1}>
                {membersInTeam ? <Grid.Column textAlign='left'>
                    <div style={{ marginBottom: 5, fontWeight: "bold" }}>Lista zawodników</div>
                    {membersInTeam?.length > 0 ? <List ordered>{membersInTeam.map((row, i) => <List.Item style={{ lineHeight: "7px" }} key={i}>{row.member_name}</List.Item>)} </List> : "Brak zawodników"}
                </Grid.Column> : ""}
                {additionaInfo ? <Grid.Column textAlign='left'>
                    <div style={{ marginBottom: 5, fontWeight: "bold" }}>Informacje dodatkowe</div>
                    {get_additional_info(additionaInfo)}
                </Grid.Column> : ""}

            </Grid>
    )
}

export default GetTooltipMemberTG;